<template>
<div>
  <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加</el-button>
  <el-dialog :visible="dialogVisible" title="新建模版" width="1000px" @close="closeDialog">
    <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="名称：" prop="modeName">
        <el-input v-model="detail.modeName"></el-input>
      </el-form-item>
      <el-form-item label="内容：" prop="modeContent">
        <el-input type="textarea" v-model="detail.modeContent"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'createMessageTemplate',
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        modeName: {
          required: true,
          message: '请填写名称'
        },
        modeContent: {
          required: true,
          message: '请填写内容'
        }
      }
    };
  },
  methods: {
    ...mapActions('messageTemplate', ['createMessageTemplate']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.createMessage(this.detail).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.dialogVisible = false;
            this.$emit('refresh', {
              page: 1
            });
          });
        }
      });
    }
  }
};
</script>
